import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// import images
import logo from '../../images/logo.png';

class Footer extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<React.Fragment>
				<footer className='footer'>
					<div className='container'>
						<div className='row'>
							<div className='col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2'>
								<Link className='logo-footer' to='/'>
									<img
										src={logo}
										alt='logo'
										className='bg-white p-2 py-3'
										style={{ borderRadius: '20px', maxHeight: '120px' }}
									/>
								</Link>
								<p className='mt-4'>
									Being a bridge between the students and management, we strive
									to serve you in delivering the best student experience ever!
								</p>
								<ul className='list-unstyled social-icon social mb-0 mt-4'>
									<li className='list-inline-item'>
										<a
											href='https://www.facebook.com/TCStudentCouncil/'
											className='rounded mr-1'
										>
											<i className='mdi mdi-facebook' title='Facebook'></i>
										</a>
									</li>
									<li className='list-inline-item'>
										<a
											href='https://www.instagram.com/tcscstudentcouncil/'
											className='rounded mr-1'
										>
											<i className='mdi mdi-instagram' title='Instagram'></i>
										</a>
									</li>
								</ul>
							</div>

							<div className='col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0'>
								<h4 className='text-light footer-head'>Links</h4>
								<ul className='list-unstyled footer-list mt-4'>
									<li>
										<Link to='/team' className='text-foot'>
											<i className='mdi mdi-chevron-right mr-1'></i>Team
										</Link>
									</li>
									<li>
										<Link to='/hotc' className='text-foot'>
											<i className='mdi mdi-chevron-right mr-1'></i>Humans of
											Taylor's College
										</Link>
									</li>
									<li>
										<Link
											to='forms.gle/qjHWKpdBvQRWVLiQ8'
											className='text-foot'
										>
											<i className='mdi mdi-chevron-right mr-1'></i>TCSC X
											Taylor's Content Team
										</Link>
									</li>
									<li>
										<Link to='/apply' className='text-foot'>
											<i className='mdi mdi-chevron-right mr-1'></i>Apply To
											TCSC
										</Link>
									</li>
									<li>
										<Link to='/events' className='text-foot'>
											<i className='mdi mdi-chevron-right mr-1'></i>Events
										</Link>
									</li>
									<li>
										<Link to='/contact' className='text-foot'>
											<i className='mdi mdi-chevron-right mr-1'></i>Contact
										</Link>
									</li>
								</ul>
							</div>

							<div className='col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0'>
								<h4 className='text-light footer-head'>Featured Events</h4>
								<ul className='list-unstyled footer-list mt-4'>
									<li>
										<Link to='/event/social-vibes' className='text-foot'>
											<i className='mdi mdi-chevron-right mr-1'></i>Social Vibes
										</Link>
									</li>
									<li>
										<Link to='/event/taylimpics-2019' className='text-foot'>
											<i className='mdi mdi-chevron-right mr-1'></i>Taylimpics
											2019
										</Link>
									</li>
									<li>
										<Link
											to='/event/international-women-s-day'
											className='text-foot'
										>
											<i className='mdi mdi-chevron-right mr-1'></i>
											International Women's Day
										</Link>
									</li>
									<li>
										<Link
											to='/event/international-mental-health-awareness-day'
											className='text-foot'
										>
											<i className='mdi mdi-chevron-right mr-1'></i>
											International Mental Health Awareness Day
										</Link>
									</li>
									<li>
										<Link to='/event/movie-mayhem' className='text-foot'>
											<i className='mdi mdi-chevron-right mr-1'></i>
											Movie Mayhem
										</Link>
									</li>
								</ul>
							</div>
							<div className='col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0'>
								<h4 className='text-light footer-head'>Newsletter</h4>
								<p className='mt-4'>
									Sign up and receive the latest tips via email.
								</p>
								<form
									action='https://gmail.us4.list-manage.com/subscribe/post'
									method='POST'
								>
									<div className='row'>
										<div className='col-lg-12'>
											<div className='foot-subscribe form-group position-relative'>
												<label>
													Write your email
													<span className='text-danger'>*</span>
												</label>
												<i className='mdi mdi-email ml-3 icons'></i>
												<input
													type='hidden'
													name='u'
													value='70607d410a4b6cee7788158b0'
												/>
												<input type='hidden' name='id' value='62c947a55c' />
												<input
													name='MERGE0'
													id='MERGE0'
													type='email'
													className='form-control pl-5 rounded'
													placeholder='Your email :'
													required=''
													aria-describedby='newssubscribebtn'
												/>
											</div>
										</div>
										<div className='col-lg-12'>
											<input
												type='submit'
												id='submitsubscribe'
												name='send'
												className='btn btn-primary w-100'
												value='Subscribe'
											/>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</footer>
				<hr />
				<footer className='footer footer-bar'>
					<div className='container text-center'>
						<div className='row align-items-center'>
							<div className='col-sm-6'>
								<div className='text-sm-left'>
									<p className='mb-0'>
										© {new Date().getFullYear()} Taylor's College Student
										Council
									</p>
								</div>
							</div>
							<div className='col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0'>
								<div className='text-sm-right'>
									<p className='mb-0'>
										Made with <i className='mdi mdi-heart mr-1' />
									</p>
								</div>
							</div>
						</div>
					</div>
				</footer>
			</React.Fragment>
		);
	}
}

export default Footer;
